const SHARE_POPUP_FEATURES = 'width=640,height=380,modal=yes,left=100,top=50,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no,noopener,noreferrer';
let isBound = false;

const openSharePopup = (link) => {
    if (!link?.href) {
        return;
    }

    const popup = window.open(link.href, '', SHARE_POPUP_FEATURES);
    if (popup) {
        popup.opener = null;
        return;
    }

    window.location.href = link.href;
};

const isModifiedClick = (event) => {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
};

export const initSyndicationActions = () => {
    if (isBound || typeof document === 'undefined') {
        return;
    }

    isBound = true;

    document.addEventListener('click', (event) => {
        if (isModifiedClick(event)) {
            return;
        }

        const printTrigger = event.target.closest('[data-print-trigger]');
        if (printTrigger) {
            event.preventDefault();
            window.print();
            return;
        }

        const popupLink = event.target.closest('a[data-share-popup]');
        if (popupLink) {
            event.preventDefault();
            openSharePopup(popupLink);
        }
    });
};
